/* eslint-disable */
import React, { useState } from "react";
import { useTranslation } from "../../locale/useTranslation";
import "./MediaExtensionEditForm.css";
import { utility } from "../../framework/utility/utilityProvider";
import { LOCALSTORAGE_KEY } from "../../framework/constant/constant";

const MediaExtensionEditForm = (props) => {

    const { item, onChangeExtensionData, isLong = false } = props;

    const lang = useTranslation();
    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const isEncompass = company && company.Name && company.Name.toLowerCase() === "encompass";

    const blankDataItem = {
        episodeNumberForPress: item?.episodeNumberForPress ?? "",
        totalEpisodes: item?.totalEpisodes ?? "",
        contentPlatform: item?.contentPlatform ?? "",
        originCountries: item?.originCountries ?? "",
        Studio: item?.Studio ?? "",
        programmeLanguageId: item?.programmeLanguageId ?? "",
        imageUrl1: item?.imageUrl1 ?? "",
        imageUrl2: item?.imageUrl2 ?? "",
        cableVOD: item?.cableVOD ?? false,
        iptvVOD: item?.iptvVOD ?? false,
        internetVOD: item?.internetVOD ?? false,
        ottVOD: item?.ottVOD ?? false,
        ssaiVOD: item?.ssaiVOD ?? false,
        downloadVideo: item?.downloadVideo ?? false,
        videoFormat: item?.videoFormat ?? "",
        shortDisplayTitle: item?.shortDisplayTitle ?? "",
        shortDisplayTitleChinese: item?.shortDisplayTitleChinese ?? "",
        thumbnailRequiredFlag: item?.thumbnailRequiredFlag ?? false,
        gameId: item?.gameId ?? "",
        homeTeam: item?.homeTeam ?? "",
        awayTeam: item?.awayTeam ?? "",
        newTitle: item?.newTitle ?? false,
        audioLanguage1: item?.audioLanguage1 ?? "",
        audioLanguage2: item?.audioLanguage2 ?? "",
        subtitleEmbedded: item?.subtitleEmbedded ?? false,
        closedCaptionFileFormat: item?.closedCaptionFileFormat ?? "",
        subtitleFileName: item?.subtitleFileName ?? "",
        subtitleLanguages: item?.subtitleLanguages ?? "",
        audioMode: item?.audioMode ?? "",
        censorship: item?.censorship ?? false,
        folderName: item?.folderName ?? "",
        audioTrack: item?.audioTrack ?? "",
        etvDisplay: item?.etvDisplay ?? false,
        isStartOver: item?.isStartOver ?? false,
        ChannelVersionID: item?.ChannelVersionID ?? "",
    };


    const [dataItem, setDataItem] = useState(blankDataItem);

    const prepareSaveData = (data) => {

        return {
            episodeNumberForPress: data?.episodeNumberForPress ?? "",
            totalEpisodes: data?.totalEpisodes ? parseInt(data.totalEpisodes) : null,
            contentPlatform: data?.contentPlatform ?? "",
            originCountries: data?.originCountries ?? "",
            Studio: data?.Studio ?? "",
            programmeLanguageId: data?.programmeLanguageId ?? "",
            imageUrl1: data?.imageUrl1 ?? "",
            imageUrl2: data?.imageUrl2 ?? "",
            cableVOD: data?.cableVOD ?? false,
            iptvVOD: data?.iptvVOD ?? false,
            internetVOD: data?.internetVOD ?? false,
            ottVOD: data?.ottVOD ?? false,
            ssaiVOD: data?.ssaiVOD ?? false,
            downloadVideo: data?.downloadVideo ?? false,
            videoFormat: data?.videoFormat ?? "",
            shortDisplayTitle: data?.shortDisplayTitle ?? "",
            shortDisplayTitleChinese: data?.shortDisplayTitleChinese ?? "",
            thumbnailRequiredFlag: data?.thumbnailRequiredFlag ?? false,
            gameId: data?.gameId ?? "",
            homeTeam: data?.homeTeam ?? "",
            awayTeam: data?.awayTeam ?? "",
            newTitle: data?.newTitle ?? false,
            audioLanguage1: data?.audioLanguage1 ?? "",
            audioLanguage2: data?.audioLanguage2 ?? "",
            subtitleEmbedded: data?.subtitleEmbedded ?? false,
            closedCaptionFileFormat: data?.closedCaptionFileFormat ?? "",
            subtitleFileName: data?.subtitleFileName ?? "",
            subtitleLanguages: data?.subtitleLanguages ?? "",
            audioMode: data?.audioMode ?? "",
            censorship: data?.censorship ?? false,
            folderName: data?.folderName ?? "",
            audioTrack: data?.audioTrack ?? "",
            etvDisplay: data?.etvDisplay ?? false,
            isStartOver: data?.isStartOver ?? false,
            ChannelVersionID: data?.ChannelVersionID ?? "",
        };
    };

    const onChange = (e) => {
        let updatedData = { ...dataItem };

        if (e.target.name === 'cableVOD') {
            updatedData.cableVOD = !dataItem.cableVOD;
        } else if (e.target.name === 'iptvVOD') {
            updatedData.iptvVOD = !dataItem.iptvVOD;
        } else if (e.target.name === 'internetVOD') {
            updatedData.internetVOD = !dataItem.internetVOD;
        } else if (e.target.name === 'ottVOD') {
            updatedData.ottVOD = !dataItem.ottVOD;
        } else if (e.target.name === 'ssaiVOD') {
            updatedData.ssaiVOD = !dataItem.ssaiVOD;
        } else if (e.target.name === 'downloadVideo') {
            updatedData.downloadVideo = !dataItem.downloadVideo;
        } else if (e.target.name === 'thumbnailRequiredFlag') {
            updatedData.thumbnailRequiredFlag = !dataItem.thumbnailRequiredFlag;
        } else if (e.target.name === 'newTitle') {
            updatedData.newTitle = !dataItem.newTitle;
        } else if (e.target.name === 'subtitleEmbedded') {
            updatedData.subtitleEmbedded = !dataItem.subtitleEmbedded;
        } else if (e.target.name === 'censorship') {
            updatedData.censorship = !dataItem.censorship;
        } else if (e.target.name === 'etvDisplay') {
            updatedData.etvDisplay = !dataItem.etvDisplay;
        } else if (e.target.name === 'isStartOver') {
            updatedData.isStartOver = !dataItem.isStartOver;
        } else {
            updatedData[e.target.name] = e.target.value;
        }
        setDataItem(updatedData);
        onChangeExtensionData(prepareSaveData(updatedData));
    };

    const renderField = ({ label, name, type = "text", value, onFieldChange = onChange, disabled = false }) => (
        <div className="col-lg-4 col-md-6 media-extension-field">
            <label className="app-form-label-compact media-extension-label">{label}</label>
            <input
                type={type}
                name={name}
                value={value ?? dataItem[name]}
                onChange={onFieldChange}
                className="form-control media-extension-input"
                disabled={disabled}
            />
        </div>
    );

    const renderCheckbox = ({ name, label }) => (
        <div className="media-extension-checkbox-item" key={name}>
            <label className="media-extension-checkbox-label">
                <input
                    name={name}
                    type="checkbox"
                    checked={!!dataItem[name]}
                    onChange={onChange}
                    className="media-extension-checkbox-input"
                />
                <span>{label}</span>
            </label>
        </div>
    );


    return (

        <div className="container-fluid media-extension-form" style={isLong ? { maxHeight: "45vh", overflowY: "auto", overflowX: "hidden", paddingRight: "5px" } : {}}>
            <div className="media-extension-section">
                <h6 className="media-extension-section-title">{lang.general_label}</h6>
                <div className="row">
                    {renderField({ label: lang.episode_number_for_press_label, name: "episodeNumberForPress" })}
                    {renderField({ label: lang.total_episodes_label, name: "totalEpisodes", type: "number" })}
                    {renderField({ label: lang.content_platform_label, name: "contentPlatform" })}
                    {renderField({ label: lang.origin_countries_label, name: "originCountries" })}
                    {renderField({ label: lang.channel_number_label, name: "ChannelVersionID" })}
                    {renderField({ label: lang.folder_name_label, name: "folderName" })}
                    {renderField({ label: lang.studio_label, name: "Studio" })}
                </div>
                <div className="media-extension-checkbox-grid">
                    {renderCheckbox({ name: "censorship", label: lang.censorship_label })}
                    {renderCheckbox({ name: "etvDisplay", label: lang.etv_display_label })}
                    {renderCheckbox({ name: "isStartOver", label: lang.is_start_over_label })}
                    {renderCheckbox({ name: "newTitle", label: lang.new_title_label })}
                </div>
            </div>

            {/* {!isLong && (
                <div className="media-extension-section">
                    <h6 className="media-extension-section-title">Validity</h6>
                    <div className="row">
                        {renderField({
                            label: lang.validity_start_label,
                            name: "validityStart",
                            type: "date",
                            value: dataItem.validity.validityStart,
                            onFieldChange: onValidityChange
                        })}
                        {renderField({
                            label: lang.validity_end_label,
                            name: "validityEnd",
                            type: "date",
                            value: dataItem.validity.validityEnd,
                            onFieldChange: onValidityChange
                        })}
                        {renderField({
                            label: lang.premier_start_date_label,
                            name: "premierStartDate",
                            type: "date",
                            value: dataItem.validity.premierStartDate,
                            onFieldChange: onValidityChange
                        })}
                        {renderField({
                            label: lang.premier_start_time_label,
                            name: "premierStartTime",
                            type: "time",
                            value: dataItem.validity.premierStartTime,
                            onFieldChange: onValidityChange
                        })}
                        {renderField({
                            label: lang.premier_end_date_label,
                            name: "premierEndDate",
                            type: "date",
                            value: dataItem.validity.premierEndDate,
                            onFieldChange: onValidityChange
                        })}
                        {renderField({
                            label: lang.premier_end_time_label,
                            name: "premierEndTime",
                            type: "time",
                            value: dataItem.validity.premierEndTime,
                            onFieldChange: onValidityChange
                        })}
                    </div>
                </div>
            )} */}

            <div className="media-extension-section">
                <h6 className="media-extension-section-title">{lang.images_label}</h6>
                <div className="row">
                    {renderField({ label: isEncompass ? lang.image_url1_landscape_label : lang.image_url1_label, name: "imageUrl1" })}
                    {renderField({ label: isEncompass ? lang.image_url2_portrait_label : lang.image_url2_label, name: "imageUrl2" })}
                </div>
                <div className="media-extension-checkbox-grid">
                    {renderCheckbox({ name: "thumbnailRequiredFlag", label: lang.thumbnail_required_label })}
                </div>
            </div>

            <div className="media-extension-section">
                <h6 className="media-extension-section-title">{lang.subtitle_label}</h6>
                <div className="row">
                    {renderField({ label: lang.subtitle_languages_label, name: "subtitleLanguages" })}
                    {renderField({ label: lang.subtitle_file_name_label, name: "subtitleFileName" })}
                    {renderField({ label: lang.closed_caption_file_format_label, name: "closedCaptionFileFormat" })}
                </div>
                <div className="media-extension-checkbox-grid">
                    {renderCheckbox({ name: "subtitleEmbedded", label: lang.subtitle_embedded_label })}
                </div>
            </div>

            <div className="media-extension-section">
                <h6 className="media-extension-section-title">{lang.sports_label}</h6>
                <div className="row">
                    {renderField({ label: lang.game_id_label, name: "gameId" })}
                    {renderField({ label: lang.home_team_label, name: "homeTeam" })}
                    {renderField({ label: lang.away_team_label, name: "awayTeam" })}
                </div>
            </div>


            <div className="media-extension-section">
                <h6 className="media-extension-section-title">{lang.audio_and_video_label}</h6>
                <div className="row">
                    {/* {renderField({ label: lang.program_language_id_label, name: "programmeLanguageId" })} */}
                    {renderField({ label: lang.audio_mode_label, name: "audioMode" })}
                    {/* {renderField({ label: lang.audio_track_label, name: "audioTrack" })} */}
                    {/* {renderField({ label: lang.audio_language1_label, name: "audioLanguage1" })} */}
                    {/* {renderField({ label: lang.audio_language2_label, name: "audioLanguage2" })} */}
                    {renderField({ label: lang.video_format_label, name: "videoFormat" })}
                </div>
            </div>

            <div className="media-extension-section">
                <h6 className="media-extension-section-title">{lang.platform_label}</h6>
                <div className="media-extension-checkbox-grid">
                    {renderCheckbox({ name: "cableVOD", label: lang.cable_vod_label })}
                    {renderCheckbox({ name: "iptvVOD", label: lang.iptv_vod_label })}
                    {renderCheckbox({ name: "internetVOD", label: lang.internet_vod_label })}
                    {renderCheckbox({ name: "ottVOD", label: lang.ott_vod_label })}
                    {renderCheckbox({ name: "ssaiVOD", label: lang.ssai_vod_label })}
                    {renderCheckbox({ name: "downloadVideo", label: lang.download_video_label })}
                </div>
            </div>
        </div>
    );
};

export default MediaExtensionEditForm

